<div *ngIf="dialog_type === 'delete-dialog-open'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">Are you sure you want to permanently remove?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Delete
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      Cancel
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'BAtterystatusgraph'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Battery Status Graph</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <div
        id="BatterystatusChart"
        style="
          height: 370px;
          width: 100%;
          margin-left: auto;
          margin-right: auto;
        "
      >
        <!-- <P>GRAPH TO BE IMPLEMENTED HERE</P> -->
        <div class="line_chart_outer" *ngIf="chartLayoutOn">
          <!-- <img
          *ngIf="!visibilityVAT"
          class="chart_load"
          src="./assets/chart_loader.gif"
          id="loader"
        /> -->
          <p *ngIf="chartLayoutOff" class="no_avl_data_msg">
            No data available for last 24 hour
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      OK
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'delete-asset-dialog'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">Are you sure you want to permanently remove?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Delete
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      Cancel
    </button>
  </div>
</div>
<div *ngIf="dialog_type === 'Update Weightage'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Update Indices Weightage</h4>
  </div>
  <div class="modal-body">
    <div>
      <p class="m_0">Sum of all these parametrs should sums to 100 %</p>
      <form
        class="updateHealth"
        [formGroup]="HealthindicesForm"
        (ngSubmit)="UpdateHealthIndices()"
      >
        <div class="formGroup">
          <label for="Mechanical_Health">Mechanical Health </label>
          <input
            id="Mechanical_Health"
            type="number"
            formControlName="Mechanical_Health"
          />
        </div>
        <div class="formGroup">
          <label for="Electrical_Health">Electrical Health</label>
          <input
            id="Electrical_Health"
            type="number"
            formControlName="Electrical_Health"
          />
        </div>
        <div class="formGroup">
          <label for="Bearings_Health">Bearings Health</label>
          <input
            id="Bearings_Health"
            type="number"
            formControlName="Bearings_Health"
          />
        </div>
        <div class="formGroup">
          <label for="Thermal_Health">Thermal Health</label>
          <input
            id="Thermal_Health"
            type="number"
            formControlName="Thermal_Health"
          />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            mat-raised-button
            color="primary"
            type="submit"
            cdkFocusInitial
          >
            Update
          </button>
          <button type="button" mat-stroked-button color="warn" (click)="onNoClick()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="dialog_type === 'delete-dialog-open-with-childs'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">Not able to remove. Need to remove it's child first.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
      disabled="true"
    >
      Delete
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      Cancel
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'discard-changes-dialog-box'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">Do you want to discard form changes?</p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Yes
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      No
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'discard-changes-radio'" class="del_popup">
  <div class="modal-header">
    <h4 class="modal-title">Alert</h4>
  </div>
  <div class="modal-body">
    <div class="flexnalign m_t_20 m_b_20">
      <img
        style="height: 40px; width: 40px"
        class="m_r_10"
        src="assets/warning.png"
        onerror="this.src='assets/warning.png'"
      />
      <p class="m_0">
        Do you really want to switch motor ? <br />
        Your all current changes will reset.
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Yes
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      No
    </button>
  </div>
</div>

<div *ngIf="dialog_type == 'motorPlateDialogBox'" id="motor_plateModal">
  <div class="modal-header">
    <h4 class="modal-title">Motor name plate details</h4>
  </div>
  <div class="modal-body">
    <div class="div_table">
      <div class="inner">
        <div class="list">
          <div class="left">
            <p>Application</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.application.name }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Site</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.site.name }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Motor name</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.name }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Frame</p>
          </div>
          <div class="right">
            <p>
              {{ deviceStausInfo.frame }}&nbsp;{{ deviceStausInfo.frame_unit }}
            </p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Insulation Class</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.insulation_class }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Duty</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.duty || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Rated ambient temperature</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.rated_ambient_temprature }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Motor serial #</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.motor_serial_no || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Rated power</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.rated_power || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Rated RPM</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.rated_rpm || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Rated voltage</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.rated_voltage || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Mac Address</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo.device.mac_address }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Line frequency</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.line_frequency || "--" }}</p>
          </div>
        </div>
        <div class="list">
          <div class="left">
            <p>Power factor</p>
          </div>
          <div class="right">
            <p>{{ deviceStausInfo?.power_factor || "--" }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>

<!--**********************************dummy****************************************-->
<div *ngIf="dialog_type == 'auditDialogBox'" class="sensor_threshold_popup">
  <div class="modal-header">
    <h4 class="modal-title">Updated Configurations</h4>
    <button
      style="color: white !important; border: unset; background: transparent"
      type="button"
      data-dismiss="modal"
      [mat-dialog-close]=""
      cdkFocusInitial
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Close
    </button>
  </div>
  <div style="max-height: 450px; overflow-y: scroll">
    <ngx-json-viewer [json]="auditData" [expanded]="true"></ngx-json-viewer>
  </div>
</div>

<div *ngIf="dialog_type == 'sensorNewDialogBox'" class="sensor_threshold_popup foroverflow">
  <div class="modal-header">
    <h4 class="modal-title">Sensor Threshold Value</h4>
  </div>
  <div class="header">
    <div class="playerOne">Fault Determination Criteria:</div>
    <div class="playerTwo">
      <section class="fft-base-section">
        <mat-radio-group
          [(ngModel)]="fftBaseValue"
          (change)="onChangeFFTBaseValue()"
        >
          <mat-radio-button class="r1-btn-margin" value="AC">
            Acceleration
          </mat-radio-button>
          <mat-radio-button class="r2-btn-margin" value="VEL">
            Velocity
          </mat-radio-button>
        </mat-radio-group>
      </section>
    </div>
  </div>

  <p style="font-size: 12px; margin-left: 16px; margin-bottom: 0px">
    Note: Vibration severity thresholds as per the ISO 10816. Users can change
    the thresholds, if so required
  </p>

  <div class="modal-body">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Sensor Group</th>
            <th>Range</th>
            <th>Green</th>
            <th>Yellow</th>
            <th>Red</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let _Sensor of _sensorGroupData; let i = index">
            <td
              *ngIf="_Sensor.metric_type !== 'sound'"
              id="title_value_{{ i }}"
            >
              {{ _Sensor.metric_type }}
            </td>
            <td
              *ngIf="_Sensor.metric_type === 'sound'"
              id="title_value_{{ i }}"
            >
              Delta Ultrasound (dB)
            </td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_70 m_r_10">
                  <input
                    type="text"
                    id="base_value_{{ i }}"
                    value="{{ _Sensor.base_value }}"
                    class="form-control"
                    (input)="onInputChange()"
                    placeholder="Min"
                  />
                </div>
                <div class="input-group width_70">
                  <input
                    type="text"
                    id="max_value_{{ i }}"
                    value="{{ _Sensor.max_value }}"
                    class="form-control"
                    (input)="onInputChange()"
                    placeholder="Max"
                  />
                </div>
              </div>
            </td>
            <td>
              <div class="input-group width_100">
                <input
                  type="text"
                  id="threshold_1_{{ i }}"
                  value="{{ _Sensor.threshold_1 }}"
                  (input)="onInputChange()"
                  class="form-control"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_100">
                  <input
                    type="text"
                    id="threshold_2_{{ i }}"
                    value="{{ _Sensor.threshold_2 }}"
                    (input)="onInputChange()"
                    class="form-control"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="input-group width_100">
                <input
                  type="text"
                  id="threshold_3_{{ i }}"
                  value="{{ _Sensor.threshold_3 }}"
                  (input)="onInputChange()"
                  class="form-control"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 class="sub-title">Velocity Threshold</h4>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th *ngIf="assetType === 'MOTOR'">Machine Rating</th>
            <th *ngIf="assetType === 'PUMP'">Machine Rating</th>
            <th *ngIf="assetType === 'COMPRESSOR'">Machine Rating</th>
            <th *ngIf="assetType === 'JOURNAL_BEARING'">Machine Rating</th>
            <th *ngIf="assetType === 'FAN_BLOWER'">Machine Rating</th>
            <th *ngIf="assetType === 'GEAR'">Gear Velocity Threshold</th>
            <th>Green<span>(mm/sec)</span></th>
            <th>Yellow<span>(mm/sec)</span></th>
            <th>Red<span>(mm/sec)</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sensorkw of sensorKWpowerGroupData; let idx = index">
            <td *ngIf="sensorkw.metric_type === 'kwrating1'">< 15KW</td>
            <td *ngIf="sensorkw.metric_type === 'kwrating2'">15 - 75KW</td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' &&
                assetType === 'FAN_BLOWER'
              "
            >
              > 75KW
            </td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' && assetType === 'MOTOR'
              "
            >
              > 75KW
            </td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' && assetType === 'PUMP'
              "
            >
              > 75KW
            </td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' &&
                assetType === 'COMPRESSOR'
              "
            >
              > 75KW
            </td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' &&
                assetType === 'JOURNAL_BEARING'
              "
            >
              > 75KW
            </td>
            <td
              *ngIf="
                sensorkw.metric_type === 'kwrating3' && assetType === 'GEAR'
              "
            >
              Threshold
            </td>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  id="base_value_1_dev{{ idx }}"
                  value="{{ sensorkw.base_value }}"
                  class="form-control width_70 m_r_10"
                  (input)="onInputChange()"
                  disabled="true"
                />
                <input
                  type="text"
                  id="threshold_1_dev{{ idx }}"
                  value="{{ sensorkw.threshold_1 }}"
                  (input)="onInputChange()"
                  class="form-control width_70"
                />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  id="threshold_1_dev{{ idx }}"
                  value="{{ sensorkw.threshold_1 }}"
                  class="form-control width_100 m_r_20"
                  disabled="true"
                />
                <input
                  type="text"
                  id="threshold_2_dev{{ idx }}"
                  value="{{ sensorkw.threshold_2 }}"
                  (input)="onInputChange()"
                  class="form-control width_100"
                />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  id="threshold_2_dev{{ idx }}"
                  value="{{ sensorkw.threshold_2 }}"
                  class="form-control width_100 m_r_20"
                  (input)="onInputChange()"
                  disabled="true"
                />
                <input
                  type="text"
                  id="threshold_3_dev{{ idx }}"
                  value="{{ sensorkw.threshold_3 }}"
                  (input)="onInputChange()"
                  class="form-control width_100"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <h4 *ngIf="!showKurtosis" class="sub-title">Kurtosis</h4>
    <div *ngIf="!showKurtosis" class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Threshold</th>
            <th>Kurtosis Analysis Frequency (min)</th>
            <th>Anomaly Counter</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  id="kurt_threshold"
                  value="{{ kurt_threshold }}"
                  defaultValue="4"
                  (input)="onInputChange($event, _Sensor, 'max_value')"
                  max="4"
                  class="form-control width_100 m_r_20"
                />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  id="kurt_frequency"
                  (input)="onInputChange($event, _Sensor, 'max_value')"
                  value="{{ kurt_freq }}"
                  max="8"
                  min="6"
                  class="form-control width_100 m_r_20"
                />
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <input
                  type="text"
                  (input)="onInputChange($event, _Sensor, 'max_value')"
                  id="kurt_anomaly_counter"
                  min="2"
                  max="7"
                  value="{{ kurt_anomaly_counter }}"
                  class="form-control width_100 m_r_20"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <textarea
      class="form-control"
      placeholder=".....comment"
      [(ngModel)]="commentOnSetting"
    ></textarea>
  </div>
  <div class="modal-footer">
    <button
      [disabled]="data.asset_status === 2 || disableSensor==true"
      type="button"
      mat-raised-button
      color="primary"
      data-dismiss="modal"
      cdkFocusInitial
      (click)="saveSensorSettings()"
    >
      Save
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      [mat-dialog-close]=""
      cdkFocusInitial
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>
<!---------------  Plant-Dashboard-Comment ------------------------->

<div *ngIf="dialog_type == 'plantDailogBox'" id="plant_dashModal">
  <div class="modal-header">
    <h4 class="modal-title">Plant Dashboard</h4>
  </div>
  <div class="modal-body">
    <div class="modalhead_tools">
      <div class="left">
        <h4><span>Client:</span>{{ data.company_name }}</h4>
      </div>
      <div class="right">
        <div class="btn-group tab_btn_group">
          <button
            type="button"
            [ngClass]="tabColor1"
            class="btn"
            (click)="selectItem('day')"
          >
            Daily
          </button>
          <button
            type="button"
            [ngClass]="tabColor2"
            class="btn"
            (click)="selectItem('week')"
          >
            Weekly
          </button>
          <button
            type="button"
            [ngClass]="tabColor3"
            class="btn"
            (click)="selectItem('month')"
          >
            Monthly
          </button>
          <button
            type="button"
            [ngClass]="tabColor4"
            class="btn"
            (click)="selectItem('quarterly')"
          >
            Quarterly
          </button>
          <button
            type="button"
            [ngClass]="tabColor5"
            class="btn"
            (click)="selectItem('Yearly')"
          >
            Yearly
          </button>
        </div>
        <div class="btn-group view_btn_group">
          <button type="button" class="btn default_btn" (click)="download()">
            <span class="sprite_icon download_grey"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Site</th>
            <th>Application</th>
            <th>Asset</th>
            <th>Make</th>
            <th>Latest Status</th>
            <th>Diagnosed Issue</th>
            <th>% Full Load<span>(Min - Max)</span></th>
            <th>Average Stops<span>(Per day)</span></th>
            <th>Run-time<span>(Hours)</span></th>
            <th>Last Service Date</th>
            <th>Service Performed</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let plant of plantDATA">
            <td>{{ plant.site }}</td>
            <td>{{ plant.application }}</td>
            <td>{{ plant.asset }}</td>
            <td>{{ plant.make }}</td>
            <td>
              <div *ngIf="plant.status === 'HEALTHY'" class="flexnalign">
                <span class="healthy_dot m_r_5"></span>{{ plant.status }}
              </div>
              <div *ngIf="plant.status === 'UNHEALTHY'" class="flexnalign">
                <span class="unass_dot m_r_5"></span>{{ plant.status }}
              </div>
              <div *ngIf="plant.status === 'ERROR'" class="flexnalign">
                <span class="error_dot m_r_5"></span>{{ plant.status }}
              </div>
            </td>
            <td>{{ plant?.diagnosed_issue || "N/A" }}</td>
            <td>0% - {{ plant.full_load }}%</td>
            <td>{{ plant.stops }}</td>
            <td>{{ plant.run_time | number }}</td>
            <td>{{ plant?.last_service || "N/A" }}</td>
            <td>{{ plant?.service_performed || "N/A" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>

<!-----HTML of add device type popup-------->
<div *ngIf="dialog_type == 'deviceTypeDailogBox'" class="device_typeModal">
  <div class="modal-header">
    <h4 class="modal-title">Add Device</h4>
  </div>
  <div class="modal-body">
    <div class="inner">
      <div class="custom_checkbox" *ngFor="let devi of deviceLicence">
        <input
          type="checkbox"
          [value]="devi.id"
          id="{{ devi.id }}"
          (change)="checkSelectedValue($event.target)"
        />
        <label for="{{ devi.id }}">{{ devi.name }}</label>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      data-dismiss="modal"
      [mat-dialog-close]=""
      cdkFocusInitial
      (click)="clientLicenceSel()"
    >
      Add
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      [mat-dialog-close]=""
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>
<!-----HTML of add License popup-------->
<div *ngIf="dialog_type == 'addLicenseDailogBox'" class="addlicense_Modal">
  <div class="modal-header">
    <h4 class="modal-title">Add License</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Device Type</label>
        <span class="custom_select_outer">
          <select
            class="custom_select form-control"
            (change)="selectDeviceType('select1')"
            id="select1"
          >
            <option
              *ngFor="let deviceArr of deviceTypeArr"
              [(value)]="deviceArr.id"
            >
              {{ deviceArr.name }}
            </option>
          </select>
        </span>
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label
          >Quantity ({{
            quantityPreValue === undefined ? 0 : quantityPreValue.quantity || 0
          }})</label
        >
        <input type="text" class="form-control" id="qu" />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="myData"
      (click)="addDeviceType('select1')"
    >
      Add
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!-----HTML of add new device popup-------->
<div *ngIf="dialog_type == 'addNewDeviceDailogBox'" class="addnewdevice_Modal">
  <div class="modal-header">
    <h4 class="modal-title">Add Device</h4>
  </div>
  <div class="modal-body">
    <form>
       <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Product Type</label>
        <select
          class="form-control"
          [(ngModel)]="data.device_category_id"
          [ngModelOptions]="{ standalone: true }"
          (change)="onProductTypeChange($event)"
        >
          <option [value]="null" *ngIf="!data.device_category_id">Select Product</option>
          <option *ngFor="let product of productsList" [value]="product.id">
            {{ product.name }}
          </option>
        </select>
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20" *ngIf="data.device_category_id == 5">
        <label>Gateway Type</label>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="gatewayType"
            [value]="1"
            [(ngModel)]="data.is_piezo"
            [ngModelOptions]="{ standalone: true }"
          />
          <label class="form-check-label">Piezo</label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="gatewayType"
            [value]="0"
            [(ngModel)]="data.is_piezo"
            [ngModelOptions]="{ standalone: true }"
          />
          <label class="form-check-label">Normal</label>
        </div>
      </div>

      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Device Type</label>

        <input
          [(ngModel)]="data.device_type"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Device Detail</label>
        <input
          [(ngModel)]="data.device_detail"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />
      </div>



      <div *ngIf="data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Mapping Configuration</label>
        <div style="display: flex;">
          <label class="radiobtn">
            <input style="margin-right: 6px;"
              type="radio"
              [(ngModel)]="data.config_mapping"
              [ngModelOptions]="{ standalone: true }"
              value="no"
              [disabled]="data.device_category_id != 3"
            />
            No
          </label>
          <label class="radiobtn">
            <input style="margin-right: 6px;"
              type="radio"
              [(ngModel)]="data.config_mapping"
              [ngModelOptions]="{ standalone: true }"
              value="yes"
              [disabled]="data.device_category_id != 3"
            />
            Yes
          </label>
        </div>
      </div>

      <div *ngIf="data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20">
          <label>Communication Type</label>
          <select
            class="form-control"
            [(ngModel)]="data.communication_type"
            [ngModelOptions]="{ standalone: true }"
            (change)="onCommunicationTypeChange($event)"
          >
            <!-- Option to display when no value is selected -->
            <option [value]="null" *ngIf="!data.communication_type">Select Communication Type</option>

            <!-- Loop through communicationType array to create options -->
            <option *ngFor="let communication of communicationType" [value]="communication.key">
              {{ communication.value }}
            </option>
          </select>
        </div>

      <ng-container *ngIf="showAdditionalFields">

          <!-- <div class="col-md-12 p_l_5 p_r_5 m_b_20">
            <label>Starting "Device Type" Number</label>
            <select class="form-control" [(ngModel)]="data.device_start_number" [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" *ngIf="!data.device_start_number">Select a number</option>
              <option *ngFor="let num of deviceNumberRange" [ngValue]="num">{{ num }}</option>
            </select>
          </div> -->

          <div class="col-md-12 p_l_5 p_r_5 m_b_20">
            <label>Starting "Device Type" Number</label>
            <select class="form-control" [(ngModel)]="data.device_start_number" [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" *ngIf="!data.device_start_number">Select a number</option>
              <option *ngFor="let start of deviceNumberRange" [ngValue]="start">{{ start }} - {{ start + 4 }}</option>
            </select>
          </div>

      </ng-container>

          <div *ngIf="data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20">
            <label>Number of Connection Used</label>
            <select class="form-control" [(ngModel)]="data.number_of_connection" [ngModelOptions]="{ standalone: true }">
              <option [ngValue]="null" *ngIf="!number_of_connection">Select a Connection</option>
              <option *ngFor="let num of deviceConnectionRange" [ngValue]="num">{{ num }}</option>
            </select>
          </div>




    </form>
  </div>
  <div class="modal-footer">
    <button
  type="button"
  mat-raised-button
  color="primary"
  [mat-dialog-close]="data"
  cdkFocusInitial
  [disabled]="
    !data.device_category_id ||
    !data.device_type ||
    !data.device_detail ||

    (
      (data.device_category_id == 2 || data.device_category_id == 3) &&
      !data.number_of_connection
    ) ||

    (
      (data.device_category_id == 5) &&
      (!data.number_of_connection)
    )
  "
>
  Add
</button>
<!-- [disabled]="
    !data.device_category_id ||
    !data.device_type ||
    !data.device_detail ||

    (
      (data.device_category_id == 2 || data.device_category_id == 3) &&
      (!data.device_start_number || !data.number_of_connection)
    ) ||

    (
      (data.device_category_id == 5) &&
      (!data.number_of_connection)
    )
  " -->
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!------------------------------------------>
<!------------------------------------------------->

<div *ngIf="dialog_type === 'editNewDevicePop'" class="addnewdevice_Modal">

  <div class="modal-header">
    <h4 class="modal-title">Edit {{editType}}</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Product Type</label>
        <select
          class="form-control"
          [(ngModel)]="editType"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onFieldChange()"
          (change)="onProductTypeChange($event)"
          disabled="true"
        >
          <option [value]="editType">{{editType}}</option>
          <!-- <option *ngFor="let product of productsList" [value]="product.id">
            {{ product.name }}
          </option> -->
        </select>
      </div>

      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Device Type</label>
        <input
          [(ngModel)]="data.data.device_type"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onFieldChange()"
          type="text"
          class="form-control"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Device Detail</label>
        <input
          [(ngModel)]="data.data.device_detail"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onFieldChange()"
          type="text"
          class="form-control"
        />
      </div>


      <div *ngIf="data.data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Mapping Configuration</label>
        <div style="display: flex;">
          <label class="radiobtn">
            <input
              style="margin-right: 6px;"
              type="radio"
              [(ngModel)]="data.data.config_mapping"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onFieldChange()"
              value="no"
              [disabled]="data.data.device_category_id != 3"
            />
            No
          </label>
          <label class="radiobtn">
            <input
              style="margin-right: 6px;"
              type="radio"
              [(ngModel)]="data.data.config_mapping"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onFieldChange()"
              value="yes"
              [disabled]="data.data.device_category_id != 3"
            />
            Yes
          </label>
        </div>
      </div>

      <div *ngIf="data.data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20" style="margin-top: -12px;">
        <label>Communication Type</label>
        <select
            class="form-control"
            [(ngModel)]="data.data.communication_type"
            [ngModelOptions]="{ standalone: true }"
            (change)="onCommunicationTypeChange($event)"
          >
          <option [value]="null" *ngIf="!data.data.communication_type">Select Communication Type</option>
          <option *ngFor="let communication of communicationType" [value]="communication.key">
            {{ communication.value }}
          </option>
        </select>
      </div>


      <ng-container *ngIf="showAdditionalFields">

          <div class="col-md-12 p_l_5 p_r_5 m_b_20">
            <label>Starting "Device Type" Number</label>
            <select class="form-control" [(ngModel)]="data.data.device_start_number" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFieldChange()">
              <option [ngValue]="null">Select a number</option>
              <!-- <option *ngFor="let num of deviceNumberRange" [value]="num">{{ num }}  - {{ num + 4 }}</option> -->
              <option  [value]="data.data.device_start_number">{{ data.data.device_start_number }}  - {{ modbusNumber2ndNumber }}</option>
            </select>
          </div>

      </ng-container>

        <div *ngIf="data.data.device_category_id != 1" class="col-md-12 p_l_5 p_r_5 m_b_20">
          <label>Number of Connection Used</label>
          <select class="form-control" [(ngModel)]="data.data.number_of_connection" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFieldChange()">
            <option [ngValue]="null">Select a Connection</option>
            <option *ngFor="let num of deviceConnectionRange" [value]="num">{{ num }}</option>
          </select>
        </div>


    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="data"
      [disabled]="!isFormModified"
      cdkFocusInitial
    >
      Update
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!--------------------------------------------------------->

<!-----HTML of add new inventory popup-------->
<div
  *ngIf="dialog_type == 'addNewInvenDeviceDialogBox'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">Add Inventory</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="inventoryForm">
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Device Serial</label>
        <input
          [(ngModel)]="data.inventoryData.device_serial"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          formControlName="device_Serial"
          id="device_Serial"
          type="text"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Mac Address</label>
        <input
          [(ngModel)]="data.inventoryData.mac_address"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          formControlName="mac_add"
          id="mac_add"
          type="text"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20" *ngIf="data.inventoryData.device_category_id == 1">
        <label>Master Product Type</label>
        <select [(ngModel)]="data.inventoryData.master_type"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          (change)="handleProductTypeChange($event)"
          type="text">
          @if (master_products.length) {
            @for (product of master_products; track product?.id) {
              <option value={{product?.id}}>{{product?.name}}</option>
            }
          }
        </select>
      </div>

      <div class="col-md-12 p_l_5 p_r_5 m_b_20" *ngIf="data.inventoryData.device_category_id == 5">
        <label>Gateway Url</label>
        <input
          [(ngModel)]="data.inventoryData.gateway_url"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          id="gateway_url"
          type="text"
        />
      </div>


      <!-- <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Select Cloud Api</label>
        <span class="custom_select_outer">
          <select
            class="custom_select form-control"
            [(ngModel)]="data.inventoryData.cloud_url"
            [ngModelOptions]="{ standalone: true }"
          >
            <option *ngFor="let url of data.cloud_url" [value]="url.value">
              {{ url.label }}
            </option>
          </select>
        </span>
      </div> -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn primary_btn"
          [mat-dialog-close]="data"
          cdkFocusInitial
          [disabled]="!(inventoryForm.valid && inventoryForm.dirty)"
        >
          Add
        </button>
        <button
          type="button"
          class="btn default_btn"
          data-dismiss="modal"
          (click)="onNoClick()"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>

<!---------------------------------------EDIT INVENTORY--------------------------------------------->

<div
  *ngIf="dialog_type == 'addDeviceVersionDialogBox'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">Add New Version</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>FW Version</label>
        <input
          [(ngModel)]="device_version"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
          (keypress)="validateNo($event)"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>FW File</label>
        <input
          style="overflow: hidden"
          type="file"
          name="myfile"
          accept=""
          ng2FileSelect
          [uploader]="uploader"
          (change)="upload($event.target.files)"
        />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Okay
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<div
  *ngIf="dialog_type == 'addWifiVersionDialogBox'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">Add New Version</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Wifi Version</label>
        <input
          [(ngModel)]="wifi_device_version"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
          (keypress)="validateNo($event)"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Wifi File</label>
        <input
          style="overflow: hidden"
          type="file"
          name="myfile"
          accept=""
          ng2FileSelect
          [uploader]="wifiVersionUploader"
          (change)="uploadWifiVersion($event.target.files)"
        />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Okay
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<div
  *ngIf="dialog_type == 'deleteFWVersionDialogBox'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">FW Versions</h4>
  </div>
  <div class="modal-body">
    <div
      class="row"
      style="border-bottom: 1px solid #e1e1e1; margin-bottom: 10px"
    >
      <div class="col-sm"></div>
      <div class="col-sm" style="text-align: right">
        <input
          style="display: inline-block; vertical-align: middle"
          type="checkbox"
          [(ngModel)]="isAllSelected"
          name="list_name"
          value="m1"
          (change)="checkUncheckAll($event)"
        />
        <strong style="margin-left: 5px; margin-left: 5px; font-size: 14px"
          >Check / Uncheck All</strong
        >
      </div>
    </div>
    <div class="stuck">
      <div *ngIf="data.data.selectedTab === true" class="container">
        <div
          class="row"
          style="border-bottom: 1px solid #e1e1e1; margin-bottom: 10px"
          *ngFor="let version of versionsList"
        >
          <div class="col-sm" style="font-size: 14px">
            {{ version.fw_version }}
          </div>
          <div class="col-sm" style="text-align: right">
            <input
              type="checkbox"
              [(ngModel)]="version.isSelected"
              name="list_name"
              value="{{ version.id }}"
              (change)="onCheckboxChange($event)"
            />
          </div>
        </div>
      </div>

      <div *ngIf="data.data.selectedTab === false" class="container">
        <div
          class="row"
          style="border-bottom: 1px solid #e1e1e1; margin-bottom: 10px"
          *ngFor="let version of versionsList"
        >
          <div class="col-sm" style="font-size: 14px">
            {{ version.wifi_version }}
          </div>
          <div class="col-sm" style="text-align: right">
            <input
              type="checkbox"
              [(ngModel)]="version.isSelected"
              name="list_name"
              value="{{ version.id }}"
              (change)="onCheckboxChange($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn primary_btn"
      (click)="deleteVersion(data.data.selectedTab)"
    >
      Delete
    </button>
    <!-- <button type="button" class="btn primary_btn" [mat-dialog-close]="data" cdkFocusInitial>Delete</button> -->
  </div>
</div>

<div *ngIf="dialog_type == 'editNewInventoryDIALOG'" class="addnewdevice_Modal">
  <div class="modal-header">
    <h4 class="modal-title">Edit Inventory</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="inventoryForm">
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Device Serial</label>
        <input
          [(ngModel)]="data.inventoryData.device_serial"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          formControlName="device_Serial"
          id="device_Serial"
          type="text"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Mac Address</label>
        <input
          [(ngModel)]="data.inventoryData.mac_address"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          formControlName="mac_add"
          id="mac_add"
          type="text"
        />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20" *ngIf="data.inventoryData.device_category_id == 1">
        <label>Master Product Type</label>
        <select [(ngModel)]="data.inventoryData.master_type"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          type="text">
          @if (master_products.length) {
            @for (product of master_products; track product?.id) {
              <option value={{product?.id}}>{{product?.name}}</option>
            }
          }
        </select>
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_20"  *ngIf="data.inventoryData.device_category_id == 5">
        <label>Gateway Url</label>
        <input
          [(ngModel)]="data.inventoryData.gateway_url"
          [ngModelOptions]="{ standalone: true }"
          class="form-control"
          formControlName="gateway_url"
          id="gateway_url"
          type="text"
        />
      </div>

      <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Select Client</label>
        <span class="custom_select_outer">
          <select
            class="custom_select form-control"
            [(ngModel)]="data.inventoryData.client_id"
            [ngModelOptions]="{ standalone: true }"
            id="exampleFormControlSelect1"
            formControlName="exampleFormControlSelect1"
            (ngModelChange)="selectedClient($event)"
          >
            <option *ngFor="let client of data.clients" [value]="client.id">
              {{ client.company_name }}
            </option>
          </select>
        </span>
      </div>

      <!-- <div class="col-md-12 p_l_5 p_r_5 m_b_20">
        <label>Select Cloud Api</label>
        <span class="custom_select_outer">
          <select
            class="custom_select form-control"
            [(ngModel)]="data.inventoryData.cloud_url"
            [ngModelOptions]="{ standalone: true }"
          >
            <option *ngFor="let url of data.cloud_url" [value]="url.value">
              {{ url.label }}
            </option>
          </select>
        </span>
      </div> -->
      <div class="modal-footer">
        <button
          type="submit"
          [disabled]="makeUpdatedisable"
          class="btn primary_btn"
          [mat-dialog-close]="data"
          cdkFocusInitial
          [disabled]="!(inventoryForm.valid && inventoryForm.dirty)"
        >
          Update
        </button>
        <button
          type="button"
          class="btn default_btn"
          data-dismiss="modal"
          (click)="onNoClick()"
        >
          Cancel
        </button>
      </div>
    </form>
    <p style="text-align: center; font-size: 12px; color: #c90000">
      {{ msgLimit }}
    </p>
  </div>
</div>

<!--------------------------------------------------------------------------------------------------->

<!-----HTML of edit License popup-------->
<div
  *ngIf="dialog_type == 'editLicenseTypeDialogBox'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">Edit License</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>PO#</label>
        <input type="text" class="form-control" id="po_num" />
      </div>
      <div class="col-md-12 p_l_5 p_r_5 m_b_60">
        <label>PO Date</label>
        <div class="input-group custom_calender">
          <input
            class="form-control"
            placeholder="mm/dd/yyyy"
            name="dp"
            ngbDatepicker
            #d="ngbDatepicker"
            (dateSelect)="onDateSelect($event)"
          />
          <div class="input-group-append">
            <button class="btn default_btn" (click)="d.toggle()" type="button">
              <i class="material-icons dp48">date_range</i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn primary_btn" (click)="updatePODate()">
      Update
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!-----HTML of Delete device popup-------->
<div *ngIf="dialog_type == 'deleteNewDeviceDailogBox'" class="deldevice_Modal">
  <div class="modal-header">
    <h4 class="modal-title">Delete Device</h4>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete device ?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Delete
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!--**************************************************************************-->
<div *ngIf="dialog_type == 'ServiceBookOpen'" class="service_popup">
  <div class="modal-header">
    <h4 class="modal-title">Add Service Record</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="row">
        <div class="col-md-12">
          <label>Last Service Date</label>
          <div class="input-group custom_calender">
            <input
              class="form-control"
              placeholder="mm/dd/yyyy"
              name="dp"
              [(ngModel)]="data.data.last_service_date"
              [ngModelOptions]="{ standalone: true }"
              ngbDatepicker
              #d="ngbDatepicker"
            />
            <div class="input-group-append">
              <button
                class="btn default_btn"
                (click)="d.toggle()"
                type="button"
              >
                <i class="material-icons dp48">date_range</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label>Service Category</label>
          <select
            (change)="chageServiceCategory($event)"
            class="multiselect"
            style="
              width: 100%;
              height: 28px;
              font-size: 12px;
              padding-left: 7px;
              border-radius: 3px;
            "
            [(ngModel)]="data.data.service_category"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="Planned Repair/Service">
              Planned Repair/Service
            </option>
            <option value="Unplanned Repair/Service">
              Unplanned Repair/Service
            </option>
            <option value="In Service">In Service</option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <label>Last Service Performed</label>
          <div class="multiselect">
            <div class="selectBox" (click)="dropdownOpen('dropdown')">
              <input
                type="text"
                class="form-control ms_input"
                [(ngModel)]="data.data.last_service_performed"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Select"
                readonly
              />
              <div class="overSelect">
                <span class="material-icons">keyboard_arrow_down</span>
              </div>
            </div>
            <div
              id="checkboxes"
              [ngClass]="{ show: shouldShow, hide: !shouldShow }"
            >
              <div class="inner">
                <!-- <label class="lb_selected">Select</label>  -->
                <label for="one">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="one"
                      (change)="
                        changeModel($event, 'Electrical Unbalance Corrected')
                      "
                    />
                    <label for="one"></label>
                  </div>
                  Electrical Unbalance Corrected
                </label>
                <label for="four">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="four"
                      (change)="
                        changeModel($event, 'Machine DE Bearing repaired')
                      "
                    />
                    <label for="four"></label>
                  </div>
                  Machine DE Bearing repaired
                </label>
                <label for="five">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="five"
                      (change)="
                        changeModel($event, 'Machine NDE Bearing repaired')
                      "
                    />
                    <label for="five"></label>
                  </div>
                  Machine NDE Bearing repaired
                </label>
                <label for="six">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="six"
                      (change)="changeModel($event, 'Stator Winding repaired')"
                    />
                    <label for="six"></label>
                  </div>
                  Stator Winding repaired
                </label>
                <label for="seven">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="seven"
                      (change)="changeModel($event, 'Soft Foot corrected')"
                    />
                    <label for="seven"></label>
                  </div>
                  Soft Foot corrected
                </label>
                <label for="eight">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="eight"
                      (change)="changeModel($event, 'Bent Rotor Repaired')"
                    />
                    <label for="eight"></label>
                  </div>
                  Bent Rotor Repaired
                </label>
                <label for="two">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="two"
                      (change)="changeModel($event, 'Journal Bearing Repaired')"
                    />
                    <label for="two"></label>
                  </div>
                  Journal Bearing Repaired
                </label>
                <label for="three">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="three"
                      (change)="
                        changeModel($event, 'Machine Looseness corrected')
                      "
                    />
                    <label for="three"></label>
                  </div>
                  Machine Looseness corrected
                </label>
                <label for="nine">
                  <div class="custom_checkbox">
                    <input
                      type="checkbox"
                      id="nine"
                      (change)="changeModelForOther($event, 'other')"
                    />
                    <label for="nine"></label>
                  </div>
                  Other
                </label>
                <div *ngIf="showOther">
                  <input
                    type="text"
                    placeholder="Service type"
                    [(ngModel)]="newServiceType"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    style="margin-right: 10px; margin-left: 5px"
                    type="button"
                    mat-raised-button
                    color="primary"
                    (click)="addNewServiceType()"
                  >
                    Add
                  </button>
                  <button
                    type="button"
                    mat-raised-button
                    color="warn"
                    (click)="removeServiceType()"
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="tarea_head">
            <label>Service Details</label>
            <span>150 words</span>
          </div>
          <textarea
            class="form-control"
            [(ngModel)]="data.data.service_detail"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label>Service Performed By</label>
          <input
            type="text"
            [(ngModel)]="data.data.service_performed_by"
            [ngModelOptions]="{ standalone: true }"
            class="form-control"
            placeholder="Service performed by"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label>Next Service Date</label>
          <div class="input-group custom_calender">
            <input
              class="form-control"
              placeholder="mm/dd/yyyy"
              name="dp"
              [(ngModel)]="data.data.next_service_date"
              [ngModelOptions]="{ standalone: true }"
              ngbDatepicker
              #d1="ngbDatepicker"
              [minDate]="minDates"
            />

            <div class="input-group-append">
              <button
                class="btn default_btn"
                (click)="d1.toggle()"
                type="button"
              >
                <i class="material-icons dp48">date_range</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      mat-raised-button
      color="primary"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Add
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>
<div *ngIf="dialog_type == 'AlertBookOpen'" class="service_popup">
  <div class="modal-header">
    <h4 class="modal-title">Add Alert Record</h4>
  </div>
  <div class="modal-body">
    <form>
      <!-- <div class="row">
        <div class="col-md-12">
          <label>Last Service Date</label>
          <div class="input-group custom_calender">
            <input
              class="form-control"
              placeholder="mm/dd/yyyy"
              name="dp"
              [(ngModel)]="data.data.last_service_date"
              [ngModelOptions]="{ standalone: true }"
              ngbDatepicker
              #d="ngbDatepicker"
            />
            <div class="input-group-append">
              <button
                class="btn default_btn"
                (click)="d.toggle()"
                type="button"
              >
                <i class="material-icons dp48">date_range</i>
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row">
        <div class="col-md-12">
          <label>Alert Category</label>
          <select
            (change)="changeAlertCategory($event)"
            class="multiselect"
            style="
              width: 100%;
              height: 28px;
              font-size: 12px;
              padding-left: 7px;
              border-radius: 3px;
            "
          >
            <option value="">Select Alert Category</option>
            <option value="Alert acknowledged, scheduled for immediate service">
              Alert acknowledged, scheduled for immediate service
            </option>
            <option value="Alert acknowledged, under review">
              Alert acknowledged, under review
            </option>
            <option
              value="Alert acknowledged, scheduled for planned maintenance"
            >
              Alert acknowledged, scheduled for planned maintenance
            </option>
            <option value="Possible false alert, under review">
              Possible false alert, under review
            </option>
            <option value="Alert acknowledged, no action needed">
              Alert acknowledged, no action needed
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="tarea_head">
            <label>Add Comment</label>
            <span>150 words</span>
          </div>
          <textarea
            class="form-control"
            (change)="changeAlertComment($event)"
            [(ngModel)]="alertComment"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="tarea_head">
            <label>History</label>
          </div>
          <ul>
            <li *ngFor="let comment of comments">
              {{ comment.time }}---{{ comment.full_name }}----{{
                comment.alert_category
              }}----{{ comment.alert_comment }}
            </li>
          </ul>
          <div *ngIf="emptycommentmsg != ''">
            <h1 class="nocommentlogged">{{ emptycommentmsg }}</h1>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn primary_btn" (click)="onAddAlertClick()">
      Add
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<!--**************************************************************************-->
<div *ngIf="dialog_type == 'adminLicense'">
  <div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <div mat-dialog-content>
      <h6><strong>Name :</strong> license name</h6>
      <h6><strong>No. of licenses :</strong> 23527</h6>
      <h6><strong>License in use:</strong> 3</h6>
      <h6>
        <strong>License details:</strong> There is no one who loves pain itself.
      </h6>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr class="main-head-table">
              <th scope="col">No.</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="row-txt-size">
              <th scope="row">1</th>
              <td>Alex</td>
              <td>{{"example@domain.com"}}</td>
              <td>In Use</td>
              <td>
                <i style="color: green" class="material-icons"> done </i>
              </td>
            </tr>
            <tr class="row-txt-size">
              <th scope="row">2</th>
              <td>Endru</td>
              <td>{{"endru@domain.com"}}</td>
              <td>--</td>
              <td>
                <i style="color: red" class="material-icons"> clear </i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <!-- <button mat-button (click)="onNoClick()">Cancel</button> -->
    <button mat-button (click)="onNoClick()" cdkFocusInitial>Okay</button>
  </div>
</div>
<!--**********************************dummy****************************************-->
<div *ngIf="dialog_type == 'viewSentmsg'" class="sent_msg_popup">
  <div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <div mat-dialog-content class="content_div">
      <form class="example-form">
        <mat-form-field class="example-full-width frequency_field">
          <mat-label>Frequency</mat-label>
          <input matInput type="text" />
        </mat-form-field>
      </form>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr class="main-head-table">
              <th scope="col">Frequency</th>
              <th scope="col" class="text-center">
                <label class="custom_checkbox">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Lore Ipsum1</td>
              <td class="text-center">
                <label class="custom_checkbox">
                  <input type="checkbox" checked="checked" />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
            <tr>
              <td>Lore Ipsum2</td>
              <td class="text-center">
                <label class="custom_checkbox">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
            <tr>
              <td>Lore Ipsum3</td>
              <td class="text-center">
                <label class="custom_checkbox">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
            <tr>
              <td>Lore Ipsum4</td>
              <td class="text-center">
                <label class="custom_checkbox">
                  <input type="checkbox" />
                  <span class="checkmark"></span>
                </label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button mat-button (click)="onNoClick()" cdkFocusInitial>Close</button>
  </div>
</div>
<!--**************************************************************************-->
<div *ngIf="dialog_type == 'viewSite'">
  {{ description }}
</div>
<!--**************************************************************************-->
<!--**********************************screen1*******************************-->

<!--**************************************************************************-->
<div *ngIf="dialog_type == 'associateDeviceToClients'" class="common_modal">
  <div class="modal-header">
    <h4 class="modal-title">Associate device with client</h4>
    <i class="material-icons close" (click)="onNoClick()"> cancel</i>
  </div>
  <div class="modal-body text-center">
    <p>
      Selected devices: <b>{{ deviceCount }}</b>
    </p>
    <div class="client_field_flex">
      <select
        class="custom_select form-control width_400 m_l_10"
        #deviceSelect
        (change)="selectedClient(deviceSelect.value)"
      >
        <option *ngFor="let clients of clientsList" value="{{ clients.id }}">
          {{ clients.full_name }}
        </option>
      </select>
    </div>
    <p class="p_t_20" *ngIf="selectedClientName !== ''">
      Assign <b>{{ deviceCount }}</b> device to
      <b>{{ selectedClientName }}</b>
    </p>
  </div>
  <div class="modal-footer">
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button (click)="associateDevices()" cdkFocusInitial>
      Assign
    </button>
  </div>
</div>
<!--**************************************************************************-->
<!--**************************************************************************-->
<div *ngIf="dialog_type == 'userProfileView'">
  <div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col">
          <img
            class="profile_img"
            [src]="userInfo.profile_pic"
            onerror="this.src='assets/img/no.png';"
          />
        </div>
      </div>
      <div class="row">
        <div class="col pro_title">
          {{ userInfo.full_name }}
        </div>
      </div>
      <div class="row">
        <div class="col pro_subtitle">
          {{ userInfo.email }}
        </div>
      </div>
    </div>
    <div class="container" style="margin-top: 20px">
      <div class="row">
        <div class="col">
          <span class="main-side-text">Address 1: </span
          ><span class="txt_info">{{ userInfo?.address_1 || "--" }}</span>
        </div>
        <div class="col">
          <span class="main-side-text">Address 2: </span
          ><span class="txt_info"> {{ userInfo?.address_2 || "--" }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <span class="main-side-text">Phone number:</span
          ><span class="txt_info"> {{ userInfo?.phone_no || "--" }}</span>
        </div>
        <div class="col">
          <span class="main-side-text"> Associate site: </span
          ><span class="txt_info">
            {{ userInfo?.associate_site || "--" }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <span class="main-side-text"> City: </span
          ><span class="txt_info"> {{ userInfo?.city || "--" }}</span>
        </div>
        <div class="col">
          <span class="main-side-text"> State:</span
          ><span class="txt_info"> {{ userInfo?.state || "--" }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <span class="main-side-text"> Pincode: </span
          ><span class="txt_info"> {{ userInfo?.postal_code || "--" }}</span>
        </div>
        <div class="col">
          <span class="main-side-text"> Associate group:</span
          ><span class="txt_info">{{ userInfo?.associate_group || "--" }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!--**************************************************************************-->
<!--************************************************-->

<!--**************************************************************************-->
<!--************************sensor info popup************************-->

<!--*************************dummy end*******************************-->
<!--*******************************************************************-->
<div
  *ngIf="dialog_type == 'managerClientSiteGroup'"
  class="associated_user_popup"
>
  <div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <div class="input-group search_with_filter">
      <input
        type="text"
        class="form-control search_input"
        name="x"
        placeholder="Search..."
        [(ngModel)]="term"
        (input)="searchData($event.target.value)"
      />
      <div class="right_filters">
        <div class="input-group-btn search-panel">
          <button mat-button [matMenuTriggerFor]="menu1">
            <i class="material-icons">filter_list</i> Association
          </button>
          <mat-menu #menu1="matMenu">
            <button mat-menu-item (click)="filterData('All')">All</button>
            <button mat-menu-item (click)="filterData(true)">Assigned</button>
            <button mat-menu-item (click)="filterData(false)">
              Not Assigned
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="userlist_outer m_t_15">
      <span class="assign_users"
        ><b>{{ _associateUsers }}</b> Associated users assigned to this
        site.</span
      >
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr class="main-head-table">
              <th scope="col">
                <label class="custom_checkbox">
                  <input type="checkbox" disabled="disabled" />
                  <span class="checkmark"></span>
                </label>
              </th>
              <th scope="col" class="width_250">Name</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userList">
              <td>
                <label
                  class="custom_checkbox"
                  *ngIf="user.checked === true; else withoutclick"
                >
                  <input
                    type="checkbox"
                    checked="checked"
                    (click)="associateSiteUser(user)"
                  />
                  <span class="checkmark"></span>
                </label>
                <ng-template #withoutclick>
                  <label class="custom_checkbox">
                    <input type="checkbox" (click)="associateSiteUser(user)" />
                    <span class="checkmark"></span>
                  </label>
                </ng-template>
              </td>
              <td>{{ user.full_name }}</td>
              <td>{{ user.email }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<!--**************************************************************************-->
<!--*******************************************************************-->
<!--**************************************************************************-->
<!--*******************************************************************-->
<div *ngIf="dialog_type == 'ClientGroupAssociateUsers'" class="service_popup">
  <div class="modal-header">
    <h4 class="modal-title">Associated Users</h4>
  </div>
  <div class="modal-body">
    <div class="userlist_outer" *ngIf="userList.length > 0">
      <span class="assign_users"
        ><b>{{ _associateUsers }}</b> Associated users assigned to this
        Application.</span
      >
      <div
        class="table-responsive m_t_10"
        style="height: 230px; overflow: scroll; overflow-x: hidden"
      >
        <table class="table table-striped">
          <thead>
            <tr class="main-head-table">
              <th scope="col">
                <label class="cus_checkbox">
                  <input
                    type="checkbox"
                    [(ngModel)]="isChecked"
                    (click)="selectAll()"
                  />
                  <span class="checkmark"></span>
                </label>
              </th>
              <th scope="col" class="width_250">Name</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of userList">
              <td>
                <label
                  class="cus_checkbox"
                  *ngIf="user.checked === true; else withoutclick"
                >
                  <input
                    type="checkbox"
                    checked="checked"
                    (click)="associateApplicationUser(user, $event.target)"
                  />
                  <span class="checkmark"></span>
                </label>
                <ng-template #withoutclick>
                  <label class="cus_checkbox">
                    <input
                      type="checkbox"
                      (click)="associateApplicationUser(user, $event.target)"
                    />
                    <span class="checkmark"></span>
                  </label>
                </ng-template>
              </td>
              <td>{{ user.full_name }}</td>
              <td>{{ user.email }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="userlist_outer m_t_15" *ngIf="userList.length === 0">
      No Users Found
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      (click)="saveUserAssociation()"
      cdkFocusInitial
    >
      Ok
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      Cancel
    </button>
  </div>
</div>
<!--**************************************************************************-->
<!--*******************************************************************-->

<div *ngIf="dialog_type == 'assignToClientsDialog'">
  <div class="modal-header">
    <h4 class="modal-title"></h4>
  </div>
  <div class="modal-body">
    <div class="input-group search_with_filter">
      <div class="input-group-btn search-panel">
        <button mat-button [matMenuTriggerFor]="menu">
          <i class="material-icons">sort_by_alpha</i> Sort
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>Item 1</button>
          <button mat-menu-item>Item 2</button>
        </mat-menu>
      </div>
      <div class="input-group-btn search-panel">
        <button mat-button [matMenuTriggerFor]="menu">
          <i class="material-icons">filter_list</i> Filter
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>Item 1</button>
          <button mat-menu-item>Item 2</button>
        </mat-menu>
      </div>
      <input type="hidden" name="search_param" value="all" id="search_param" />
      <input
        type="text"
        class="form-control"
        name="x"
        placeholder="Search term..."
      />
      <span class="input-group-btn">
        <button class="btn btn-default" type="button">
          <i class="material-icons">search</i>
        </button>
      </span>
    </div>
    <div class="user_listing_outer" style="margin-top: 16px">
      <div
        class="list-box-one"
        fxLayout
        fxLayout.xs="column"
        fxLayoutGap="10px"
        fxLayoutGap.xs="0"
      >
        <div class="custom-padding" fxFlex="20%">
          <img
            class="list-image-custom"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBwRDpymbIBLU9lVMDgRD9w168ZXsc8RnY3_qnNEVNuCuBsAC5"
          />
        </div>
        <div class="custom-padding" fxFlex="80%">
          <h4 class="header-layout">Alexandra</h4>
          <span class="subheader-layout">{{"alexandra@domain.com"}}</span>
          <br />
          <span class="intro-style" (click)="showLicense()"
            >License:&nbsp; <span class="count-txt">10 /5</span></span
          >
        </div>
        <div class="custom-padding" fxFlex="20%">
          <button class="btn_assign" mat-button>Assign</button>
        </div>
      </div>
      <div
        class="list-box-one"
        fxLayout
        fxLayout.xs="column"
        fxLayoutGap="10px"
        fxLayoutGap.xs="0"
      >
        <div class="custom-padding" fxFlex="20%">
          <img
            class="list-image-custom"
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH3kgQOiu_hotk76_fJ-hU1v9sBiFZer0evQTkiGm4IPZn-brO"
          />
        </div>
        <div class="custom-padding" fxFlex="80%">
          <h4 class="header-layout">Emma</h4>
          <span class="subheader-layout">{{"emma@domain.com"}}</span>
          <br />
          <span class="intro-style" (click)="showLicense()"
            >License:&nbsp; <span class="count-txt">10 /5</span></span
          >
        </div>
        <div class="custom-padding" fxFlex="20%">
          <button class="btn_assign" mat-button>Assign</button>
        </div>
      </div>
      <div
        class="list-box-one"
        fxLayout
        fxLayout.xs="column"
        fxLayoutGap="10px"
        fxLayoutGap.xs="0"
      >
        <div class="custom-padding" fxFlex="20%">
          <img
            class="list-image-custom"
            src="https://content-static.upwork.com/uploads/2014/10/01073427/profilephoto1.jpg"
          />
        </div>
        <div class="custom-padding" fxFlex="80%">
          <h4 class="header-layout">Diana</h4>
          <span class="subheader-layout">{{"diana@domain.co"}}m</span>
          <br />
          <span class="intro-style" (click)="showLicense()"
            >License:&nbsp; <span class="count-txt">10 /5</span></span
          >
        </div>

        <div class="custom-padding" fxFlex="20%">
          <button class="btn_assign" mat-button>Assign</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--**************************************************************************-->

<div *ngIf="dialog_type == 'NotifyAlertStstem'" id="plant_dashModal">
  <div class="modal-header">
    <h4 class="modal-title">Alert Settings</h4>
  </div>
  <div class="modal-body">
    <div class="modalhead_tools">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Alert Category</th>
            <th>Alert Type</th>
            <th>Type</th>
            <th width="420px">
              <div class="tdDiv">
                <!-- <span><strong>Site Incharge</strong></span> -->
                <span><strong>User</strong></span>
                <span><strong>Client Admin</strong></span>
                <!-- <span><strong>Account Manager</strong></span> -->
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alertCat of alertCategory; let i = index">
            <ng-container *ngIf="i === 1">
              <td>{{ alertCat.category }}</td>

              <td>
                <div class="tdDiv" *ngFor="let catType of alertCat.type">
                  {{ catType.type }}
                </div>
              </td>
              <td>
                <div class="tdDiv" *ngFor="let catType of alertCat.type">
                  <div
                    *ngIf="
                      catType.type.includes('Service');
                      else ShowSustainedOne
                    "
                  >
                    <span>Day</span>
                  </div>
                  <ng-template #ShowSustainedOne>
                    <span *ngIf="catType.type.includes('Sustained')"
                      >Time Based</span
                    >
                    <span *ngIf="!catType.type.includes('Sustained')"
                      >Event Based</span
                    >
                  </ng-template>
                </div>
              </td>
              <td>
                <div
                  class="tdDiv"
                  *ngFor="let catType of alertCat.type; let idx = index"
                >
                  <span *ngFor="let set of catType.settings; let rowIndex = index">
                    <select
                      [(ngModel)]="set.event_counter"
                      class="custom_select form-control width_180"
                      #mySelect
                      (change)="
                        selectAlertSettings(
                          set.id,
                          set.roleId,
                          alertCat.id,
                          catType.id,
                          set.asset_id,
                          set.client_id,
                          $event.target.value
                        )
                      "
                      [disabled]="
                      (set.roleId === alertCategoryRoleIds.userId && catType.id === alertCategoryTypeIds.id1 && disabledAlertSettingsColumn.user.event) ||
                      (set.roleId === alertCategoryRoleIds.userId && catType.id === alertCategoryTypeIds.id2 && disabledAlertSettingsColumn.user.time) ||
                      (set.roleId === alertCategoryRoleIds.clientAdminId && catType.id === alertCategoryTypeIds.id1 && disabledAlertSettingsColumn.client.event) ||
                      (set.roleId === alertCategoryRoleIds.clientAdminId && catType.id === alertCategoryTypeIds.id2 && disabledAlertSettingsColumn.client.time)
                    "
                    >
                      <option
                        *ngFor="let s of catType.items"
                        value="{{ s.value }}"

                      >
                        {{ s.label }}
                      </option>
                    </select>
                  </span>
                </div>
              </td>
            </ng-container>
          </tr>
          @for (alertCat of alertCategory; track alertCat.id) {
            <tr>
              @if (alertCat.id === 5) {
                <ng-container >
                  <td>{{ alertCat.category }}</td>
                  <td>
                    @for (catType of alertCat.type; track catType.id) {
                      <div class="tdDiv">
                        {{ catType.type }}
                      </div>
                    }
                  </td>
                  <td>
                    <div class="tdDiv" *ngFor="let catType of alertCat.type">
                      <div
                        *ngIf="
                          catType.type.includes('Service');
                          else ShowSustainedOne
                        "
                      >
                        <span>Day</span>
                      </div>
                      <ng-template #ShowSustainedOne>
                        <span *ngIf="catType.type.includes('Sustained')"
                          >Time Based</span
                        >
                        <span *ngIf="!catType.type.includes('Sustained')"
                          >Event Based</span
                        >
                      </ng-template>
                    </div>
                  </td>
                  <td>
                    @for (catType of alertCat.type; track catType.id) {
                      <div class="tdDiv">
                        @for (set of catType.settings; track set.id) {
                          <span>
                            <select
                              [(ngModel)]="set.event_counter"
                              class="custom_select form-control width_180"
                              #mySelect
                              (change)="
                                selectAlertSettings(
                                  set.id,
                                  set.roleId,
                                  alertCat.id,
                                  catType.id,
                                  set.asset_id,
                                  set.client_id,
                                  $event.target.value
                                )
                              "
                            >
                            @for (s of catType.items; track s.value) {
                              <option value="{{ s.value }}">{{ s.label }}</option>
                          }
                            </select>
                          </span>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
              }
            </tr>
          }
          @if (this.masterType !== '1') {
            @for (alertCat of alertCategory; track alertCat.id) {
              <tr>
                @if (alertCat.id === 6) {
                  <ng-container >
                    <td>{{ alertCat.category }}</td>
                    <td>
                      @for (catType of alertCat.type; track catType.id) {
                        <div class="tdDiv">
                          {{ catType.type }}
                        </div>
                      }
                    </td>
                    <td>
                      <div class="tdDiv" *ngFor="let catType of alertCat.type">
                        <div
                          *ngIf="
                            catType.type.includes('Service');
                            else ShowSustainedOne
                          "
                        >
                          <span>Day</span>
                        </div>
                        <ng-template #ShowSustainedOne>
                          <span *ngIf="catType.type.includes('Sustained')"
                            >Time Based</span
                          >
                          <span *ngIf="!catType.type.includes('Sustained')"
                            >Event Based</span
                          >
                        </ng-template>
                      </div>
                    </td>
                    <td>
                      @for (catType of alertCat.type; track catType.id) {
                        <div class="tdDiv">
                          @for (set of catType.settings; track set.id) {
                            <span>
                              <select
                                [(ngModel)]="set.event_counter"
                                class="custom_select form-control width_180"
                                #mySelect
                                (change)="
                                  selectAlertSettings(
                                    set.id,
                                    set.roleId,
                                    alertCat.id,
                                    catType.id,
                                    set.asset_id,
                                    set.client_id,
                                    $event.target.value
                                  )
                                "
                              >
                                @for (s of catType.items; track s.value) {
                                    <option value="{{ s.value }}">{{ s.label }}</option>
                                }
                              </select>
                            </span>
                          }
                        </div>
                      }
                    </td>
                  </ng-container>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      mat-raised-button
      color="primary"
      cdkFocusInitial
      [disabled]="!alertSaveButton"
      (click)="saveSettings()"
    >
      Save
    </button>
    <button
      type="button"
      mat-stroked-button
      color="warn"
      data-dismiss="modal"
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>
<div *ngIf="dialog_type == 'AlertSettingsforasset'" id="plant_dashModal">
  <div class="modal-header">
    <h4 class="modal-title">Alert Settings For Asset</h4>
  </div>
  <div class="modal-body">
    <div class="modalhead_tools">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Alert Category</th>
            <th>Alert Type</th>
            <th>Type</th>
            <th width="620px">
              <div class="tdDiv">
                <span><strong>Site Incharge</strong></span>
                <span><strong>User</strong></span>
                <span><strong>Client Admin</strong></span>
                <span><strong>Account Manager</strong></span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alertCat of alertCategory">
            <td>{{ alertCat.category }}</td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                {{ catType.type }}
              </div>
            </td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                <div
                  *ngIf="
                    catType.type.includes('Service');
                    else ShowSustainedOne
                  "
                >
                  <span>Day</span>
                </div>
                <ng-template #ShowSustainedOne>
                  <span *ngIf="catType.type.includes('Sustained')"
                    >Time Based</span
                  >
                  <span *ngIf="!catType.type.includes('Sustained')"
                    >Event Based</span
                  >
                </ng-template>
              </div>
            </td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                <span *ngFor="let set of catType.settings">
                  <select
                    [(ngModel)]="set.event_counter"
                    class="custom_select form-control width_180"
                    #mySelect
                    (change)="
                      selectAlertSettings(
                        set.id,
                        set.roleId,
                        alertCat.id,
                        catType.id,
                        set.asset_id,
                        set.client_id,
                        $event.target.value
                      )
                    "
                  >
                    <option
                      *ngFor="let s of catType.items"
                      value="{{ s.value }}"
                    >
                      {{ s.label }}
                    </option>
                  </select>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="!hideAllSetBtn"
      type="button"
      class="btn primary_btn"
      cdkFocusInitial
      [disabled]="alertSaveButton"
      (click)="saveMainassetAlertSettings()"
    >
      Save
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>

<div
  *ngIf="dialog_type == 'VibratioCallibrate'"
  id="plant_dashModal"
  data-controls-modal="plant_dashModal"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-header">
    <h4 class="modal-title">Calibrate Settings For Asset</h4>
  </div>
  <div class="modal-body">
    <div class="modalhead_tools">
      <div class="left" *ngIf="startdisable">
        <p>Device is Offline</p>
      </div>
      <div class="right"></div>
    </div>
    <form [formGroup]="callibrateform" (ngSubmit)="savecallibrationdata()">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th></th>
              <th>Radial (Horizontal)</th>
              <th>Tangential (Vertical)</th>
              <th>Axial</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Reading 1</td>
              <td>
                <input
                  id="rr1"
                  type="number"
                  formControlName="rr1"
                  disabled="isReading1"
                />
              </td>
              <td>
                <input
                  id="tr1"
                  type="number"
                  formControlName="tr1"
                  disabled="isReading1"
                />
              </td>
              <td>
                <input
                  id="ar1"
                  type="number"
                  formControlName="ar1"
                  disabled="isReading1"
                />
              </td>
            </tr>
            <tr>
              <td>Reading 2</td>
              <td>
                <input
                  id="rr2"
                  type="number"
                  formControlName="rr2"
                  disabled="isReading2"
                />
              </td>
              <td>
                <input
                  id="tr2"
                  type="number"
                  formControlName="tr2"
                  disabled="isReading2"
                />
              </td>
              <td>
                <input
                  id="ar2"
                  type="number"
                  formControlName="ar2"
                  disabled="isReading2"
                />
              </td>
            </tr>
            <tr>
              <td>Reading 3</td>
              <td>
                <input
                  id="rr3"
                  type="number"
                  formControlName="rr3"
                  disabled="isReading3"
                />
              </td>
              <td>
                <input
                  id="tr3"
                  type="number"
                  formControlName="tr3"
                  disabled="isReading3"
                />
              </td>
              <td>
                <input
                  id="ar3"
                  type="number"
                  formControlName="ar3"
                  disabled="isReading3"
                />
              </td>
            </tr>
            <tr>
              <td>Reading 4</td>
              <td>
                <input
                  id="rr4"
                  type="number"
                  formControlName="rr4"
                  disabled="isReading4"
                />
              </td>
              <td>
                <input
                  id="tr4"
                  type="number"
                  formControlName="tr4"
                  disabled="isReading4"
                />
              </td>
              <td>
                <input
                  id="ar4"
                  type="number"
                  formControlName="ar4"
                  disabled="isReading4"
                />
              </td>
            </tr>
            <tr>
              <td>Reading 5</td>
              <td>
                <input
                  id="rr5"
                  type="number"
                  formControlName="rr5"
                  disabled="isReading5"
                />
              </td>
              <td>
                <input
                  id="tr5"
                  type="number"
                  formControlName="tr5"
                  disabled="isReading5"
                />
              </td>
              <td>
                <input
                  id="ar5"
                  type="number"
                  formControlName="ar5"
                  disabled="isReading5"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
  <div class="modal-footer footerBtns">
    <button
      type="button"
      class="btn primary_btn"
      cdkFocusInitial
      (click)="Startcallibration()"
      [disabled]="startdisable"
    >
      Start
    </button>
    <div>
      <p>{{ calibcompletemessage }}</p>
    </div>
    <div>
      <button
        type="button"
        class="btn default_btn"
        data-dismiss="modal"
        (click)="onNoClick()"
        cdkFocusInitial
      >
        Ok
      </button>
    </div>
  </div>
</div>

<div *ngIf="dialog_type == 'DefaultClientAlertStstem'" id="plant_dashModal">
  <div class="modal-header">
    <h4 class="modal-title">Alert Settings</h4>
  </div>
  <div class="modal-body">
    <div class="modalhead_tools">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Alert Category</th>
            <th>Alert Type</th>
            <th>Type</th>
            <th width="620px">
              <div class="tdDiv">
                <span><strong>Site Incharge</strong></span>
                <span><strong>User</strong></span>
                <span><strong>Client Admin</strong></span>
                <span><strong>Account Manager</strong></span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let alertCat of alertCategory">
            <td>{{ alertCat.category }}</td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                {{ catType.type }}
              </div>
            </td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                <div
                  *ngIf="
                    catType.type.includes('Service');
                    else ShowSustainedOne
                  "
                >
                  <span>Day</span>
                </div>
                <ng-template #ShowSustainedOne>
                  <span *ngIf="catType.type.includes('Sustained')"
                    >Time Based</span
                  >
                  <span *ngIf="!catType.type.includes('Sustained')"
                    >Event Based</span
                  >
                </ng-template>
              </div>
            </td>
            <td>
              <div class="tdDiv" *ngFor="let catType of alertCat.type">
                <span *ngFor="let set of catType.settings">
                  <select
                    [(ngModel)]="set.event_counter"
                    class="custom_select form-control width_180"
                    #mySelect
                    (change)="
                      selectAlertSettings(
                        set.id,
                        set.roleId,
                        alertCat.id,
                        catType.id,
                        set.asset_id,
                        set.client_id,
                        $event.target.value
                      )
                    "
                  >
                    <option
                      *ngFor="let s of catType.items"
                      value="{{ s.value }}"
                    >
                      {{ s.label }}
                    </option>
                  </select>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="hideAllSetBtn"
      type="button"
      class="btn primary_btn"
      cdkFocusInitial
      [disabled]="alertSaveButtonDefault"
      (click)="setDefaultSettings()"
    >
      Apply Changes
    </button>
    <button
      *ngIf="!hideAllSetBtn"
      type="button"
      class="btn primary_btn"
      cdkFocusInitial
      [disabled]="alertSaveButton"
      (click)="saveMainAlertSettings()"
    >
      Save
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
      cdkFocusInitial
    >
      Cancel
    </button>
  </div>
</div>

<div
  *ngIf="dialog_type === 'DialogForBearingNumber'"
  class="addnewdevice_Modal"
>
  <div class="modal-header">
    <h4 class="modal-title">Add Bearing Number</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Bearing Number</label>
        <input
          [(ngModel)]="data.data.bearing_number"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />

        <label>ORF</label>
        <input
          [(ngModel)]="data.data.orf"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />

        <label>IRF</label>
        <input
          [(ngModel)]="data.data.irf"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />

        <label>BCF</label>
        <input
          [(ngModel)]="data.data.bcf"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />

        <label>BBF</label>
        <input
          [(ngModel)]="data.data.bbf"
          [ngModelOptions]="{ standalone: true }"
          type="text"
          class="form-control"
        />
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Ok
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'DialogForBeltNumber'" class="addnewdevice_Modal">
  <div class="modal-header">
    <h4 class="modal-title">Add Belt Number</h4>
  </div>
  <div class="modal-body">
    <div class="col-md-12 p_l_5 p_r_5 m_b_10">
      <label>Belt Number</label>
      <input
        [(ngModel)]="data.data.belt_number"
        [ngModelOptions]="{ standalone: true }"
        type="text"
        class="form-control"
      />

      <label>Belt Length</label>
      <input
        [(ngModel)]="data.data.belt_length"
        [ngModelOptions]="{ standalone: true }"
        type="text"
        class="form-control"
      />
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn primary_btn"
      [mat-dialog-close]="data"
      cdkFocusInitial
    >
      Ok
    </button>
    <button
      type="button"
      class="btn default_btn"
      data-dismiss="modal"
      (click)="onNoClick()"
    >
      Cancel
    </button>
  </div>
</div>

<div *ngIf="dialog_type === 'showAssetsDialog'" class="Modal_childasset">
  <div
    style="margin-bottom: 10px; padding: 16px"
    *ngFor="let device of data.assetData; let i = index"
    class="box green_bg"
    [style.background-color]="device.color"
    [ngbPopover]="popContent"
    #p1="ngbPopover"
  >
    <div class="data" (click)="goToDetailScreen(device)">
      <h4 class="name bl_color">{{ device.name }}</h4>
      <p class="num smoke_color">{{ device?.motor_serial_no || "N/A" }}</p>
    </div>
    <div class="icons">
      <div *ngIf="device.connectivity_type === 'wifi'">
        <span
          *ngIf="device.live_status === 'OFFLINE'"
          class="sprite_icon wifi_red"
        ></span>
        <span
          *ngIf="device.live_status === 'ONLINE'"
          class="sprite_icon wifi_black"
        ></span>
        <span
          *ngIf="device.status === 'LIVE'"
          class="sprite_icon wifi_black"
        ></span>
      </div>
      <div *ngIf="device.connectivity_type === 'cellular'">
        <span
          *ngIf="device.live_status === 'OFFLINE'"
          class="sprite_icon nwtk_red"
        ></span>
        <span
          *ngIf="device.live_status === 'ONLINE'"
          class="sprite_icon nwtk_black"
        ></span>
        <span
          *ngIf="device.status === 'LIVE'"
          class="sprite_icon nwtk_black"
        ></span>
      </div>
      <div *ngIf="device.connectivity_type === 'bluetooth'">
        <span
          *ngIf="device.live_status === 'OFFLINE'"
          class="sprite_icon bluetooth_red"
        ></span>
        <span
          *ngIf="device.live_status === 'ONLINE'"
          class="sprite_icon bluetooth_black"
        ></span>
        <span
          *ngIf="device.status === 'LIVE'"
          class="sprite_icon bluetooth_black"
        ></span>
      </div>

      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'MOTOR'"
        src="./assets/motor.png"
      />
      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'GEAR'"
        src="./assets/engine.png"
      />
      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'PUMP'"
        src="./assets/pump.png"
      />
      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'FAN_BLOWER'"
        src="./assets/fan.png"
      />
      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'JOURNAL_BEARING'"
        src="./assets/bearing2.png"
      />
      <img
        style="height: 25px; width: 25px"
        *ngIf="device.asset_type === 'COMPRESSOR'"
        src="./assets/compressor.png"
      />

      <div id="menuCl_{{ i }}" class="dropdown">
        <button
          *ngIf="device.update_status === 0"
          class="btn dropdown-toggle"
          type="button"
          [matMenuTriggerFor]="menu"
          data-toggle="dropdown"
        >
          <span class="sprite_icon ellipse_black"></span>
        </button>
        <mat-menu #menu="matMenu">
          <a class="dropdown-item" (click)="editAssets(device.id, device)"
            >Edit</a
          >
          <a class="dropdown-item" (click)="viewAsset(device.id, i, device)"
            >Settings</a
          >
          <a
            class="dropdown-item"
            (click)="
              getDeviceInfo(
                device.inventory_id,
                i,
                device.status,
                device.id,
                'gridview'
              )
            "
            id="btnClick_{{ idx }}"
            >Plate Details</a
          >
          <a class="dropdown-item" (click)="serviceBookOpen(device.id, i)"
            >Service</a
          >
          <a
            *ngIf="userRoll === 'CLIENT'"
            class="dropdown-item"
            (click)="alertSettings(device.id, device.inventory_id)"
            >Alert Settings</a
          >
          <a
            class="dropdown-item"
            (click)="showDeleteDialog(device.id, device.inventory_id, i)"
            >Delete</a
          >
        </mat-menu>
      </div>
    </div>
  </div>

  <!-- add IP Address -->

  <!-- <div class="modal-header">
    <h4 class="modal-title">Add Belt Number</h4>
  </div>
  <div class="modal-body">
    <div class="col-md-12 p_l_5 p_r_5 m_b_10">
      <label>Belt Number</label>
      <input [(ngModel)]="data.data.belt_number" [ngModelOptions]="{standalone: true}" type="text" class="form-control">

      <label>Belt Length</label>
      <input [(ngModel)]="data.data.belt_length" [ngModelOptions]="{standalone: true}" type="text" class="form-control">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn primary_btn" [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
    <button type="button" class="btn default_btn" data-dismiss="modal" (click)="onNoClick()">Cancel</button>
  </div> -->
</div>
<div *ngIf="dialog_type == 'addIPAddress'">
  <div class="modal-header">
    <h4 class="modal-title">Add IP Address</h4>
  </div>
  <div class="modal-body">
    <form>
      <div class="col-md-12 p_l_5 p_r_5 m_b_10">
        <label>Local Server IP....</label>
        <input
          type="text"
          class="form-control"
          name="ip"
          [(ngModel)]="data.ipaddress"
          (keypress)="validateNo($event)"
        />
      </div>
    </form>
    <div class="modal-footer">
      <button
        type="button"
        class="btn primary_btn"
        [mat-dialog-close]="data"
        [disabled]=""
        cdkFocusInitial
      >
        Save
      </button>
      <button
        type="button"
        class="btn default_btn"
        data-dismiss="modal"
        (click)="onNoClick()"
      >
        Cancel
      </button>
    </div>
  </div>
</div>

<div *ngIf="dialog_type == 'ResetValues'">
  <h4 class="modal-title">Reset Values</h4>
  <div class="modal-body">
    <p>{{ data.message }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn primary_btn" (click)="confirmReset()">
      Yes
    </button>
    <button type="button" class="btn default_btn" (click)="onNoClick()">
      No
    </button>
  </div>
</div>

<div *ngIf="dialog_type == 'errorLogDialogBox'" class="error-log-details-popup">
  <div class="modal-header">
    <h4 class="modal-title">Error Log Details</h4>
    <button
      style="color: white !important; border: unset; background: transparent"
      type="button"
      [mat-dialog-close]=""
      (click)="onNoClick()"
    >
      Close
    </button>
  </div>
  <div style="max-height: 450px; overflow-y: scroll; margin: 10px">
    <p>
      <strong>Alert Category:</strong> {{ errorLogData.alertCategory || "N/A" }}
    </p>
    <table
      class="mini-table"
      style="float: left"
      *ngIf="
        errorLogData.alertCommentsHistory &&
        errorLogData.alertCommentsHistory.length > 0
      "
    >
      <thead
        style="
          border-bottom: 3px;
          border-top: 3px;
          border-left: 2px;
          border-right: 2px;
        "
      >
        <tr>
          <th>Comment</th>
          <th>Acknowledged Time</th>
          <th>Acknowledged By</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comment of errorLogData.alertCommentsHistory">
          <td>{{ comment.comment || "N/A" }}</td>
          <td>{{ comment.acknowledge_time || "N/A" }}</td>
          <td>{{ comment.acknowledged_by || "N/A" }}</td>
        </tr>
      </tbody>
    </table>
    <p
      *ngIf="
        !errorLogData.alertCommentsHistory ||
        errorLogData.alertCommentsHistory.length === 0
      "
    >
      No comments available.
    </p>
  </div>
</div>

<div
  *ngIf="dialog_type == 'serviceLogDialogBox'"
  class="service-log-details-popup"
>
  <div class="modal-header">
    <h4 class="modal-title">Service Log Details</h4>
    <button
      style="color: white !important; border: unset; background: transparent"
      type="button"
      [mat-dialog-close]=""
      (click)="onNoClick()"
    >
      Close
    </button>
  </div>
  <div style="max-height: 450px; overflow-y: scroll; margin: 10px">
    <p>
      <strong>Service Detail:</strong>
      {{ serviceLogData.serviceDetail || "N/A" }}
    </p>
    <p>
      <strong>Last Service Performed:</strong>
      {{ serviceLogData.lastServicePerformed || "N/A" }}
    </p>
    <!-- ... display other fields as needed ... -->
  </div>
</div>
<div
  id="add-schedule-form"
  class="popup-form"
  *ngIf="dialog_type === 'siteSchedule'"
>
  <div class="rectangle-1">
    <h2 class="Addscedule" *ngIf="maintenanceStatus == 'editLog'; else addsch">
      Edit Schedule
    </h2>
    <ng-template #addsch>
      <h2 class="Addscedule">Add Schedule</h2>
    </ng-template>
  </div>
  <form [formGroup]="maintenanceForm" (submit)="maintenanceLogSave()">
    <label for="title" style="position: relative; top: 50px">Title:</label
    ><br />
    <input
      type="text"
      id="title_val"
      placeholder=""
      formControlName="title_val"
      class="date-time-field"
      style="position: absolute; left: 35px; top: 102px"
    /><br />
    <label for="description" style="position: relative; top: 80px"
      >Description:</label
    ><br />
    <textarea
      id="description"
      rows="4"
      cols="40"
      formControlName="description"
      placeholder=""
      class="descriptionField"
    ></textarea>
    <br />
    <label for="start-date" style="position: relative; top: 100px"
      >Start Date and Time</label
    ><br />
    <input
      type="datetime-local"
      class="date-time-field"
      id="start_date"
      formControlName="start_date"
      [min]="minStart"
      name="start-date"
      style="left: 15px; top: 100px"
    /><br />
    <label for="end-date" style="position: relative; top: 120px"
      >End Date and Time</label
    ><br />
    <input
      type="datetime-local"
      class="date-time-field"
      id="end_date"
      formControlName="end_date"
      [min]="minEnd"
      name="end-date"
      style="left: 15px; top: 120px"
    /><br />
    <label for="end-date" style="position: relative; top: 140px"
      >Publish Date</label
    ><br />
    <input
      type="datetime-local"
      class="date-time-field"
      id="publish_date"
      [max]="maxPub"
      min="minPub"
      formControlName="publish_date"
      name="end-date"
      style="left: 15px; top: 140px"
    /><br />
    <button
      id="save-schedule"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!maintenanceForm.valid"
      style="    position: relative;
      top: 150px;
      left: 60px;"
    >
      Save
    </button>
    <button mat-stroked-button color="warn" type="reset" (click)="onNoClick()" style="    position: relative;
    top: 150px;
    left: 60px;">
      Cancel
    </button>
  </form>
</div>
  <div class="del_popup" *ngIf="dialog_type == 'outOfServiceConfirmation'">
    <div class="modal-header">
      <h4 class="modal-title">Confirm your choice</h4>
    </div>

    <div class="modal-body" style="display: flex; align-items: center; justify-content: center; padding:45px 16px;">
      <p style="font-size: 24px;">
       Are you sure you want to proceed with your selection ?
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn primary_btn" (click)="sendAssetOutForService()">
        Yes
      </button>
      <button type="button" class="btn default_btn" (click)="CancelOutForService()">
        Cancel
      </button>
    </div>
</div>
<div class="del_popup" *ngIf="dialog_type == 'showOutOfServiceDialogInitially'">
    <div class="modal-header">
      <h4 class="modal-title">{{serialNumber}} -- Important Information</h4>
    </div>

    <div class="modal-body" style="display: flex; align-items: center; justify-content: center; padding:45px 16px;">
      <p style="font-size: 24px;">
        The device is currently out-of-service. You will not be able to change settings for this device till it is back online.
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn primary_btn" (click)="CancelOutForServiceInitialModal()">
        Ok
      </button>
    </div>
</div>
<div class="del_popup" *ngIf="dialog_type == 'checkSensorDataExits'">
    <div class="modal-header">
      <h4 class="modal-title">Sensor Data Unavailable</h4>
    </div>

    <div class="modal-body" style="display: flex; align-items: center; justify-content: center; padding:45px 16px;">
      <p style="font-size: 24px;">
        The sensor data is not available right now. Please ensure that all sensors are properly connected and functioning. If the problem persists, please contact the technical support team
      </p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn primary_btn" (click)="CloseCheckSensorDataExits()">
        Ok
      </button>
    </div>
</div>


